import { type DatabaseSnapshot } from '@/entities/database';
import request from '@/shared/api/request';

export const getDatabaseSnapshots = (uuid: string): Promise<{ snapshots: DatabaseSnapshot[] }> =>
  request({
    url: `/databases/${uuid}/snapshots/`,
  });
